export enum ResultsType {
  Normal,
  Filter,
  Name,
}
